export class LocationLink {
  locationId: number;
  externalId: string;
}
